import { AuthState } from "../types/AmplifyAuth";
import { AuthWrapper } from "./AuthWrapper";

/**
 * Returns Amplify Reset Password Flow
 * @returns
 */
export const ResetPassword = () => {
    return <AuthWrapper authState={AuthState.FORCE_RESET} />;
};
